export default x => x + 1
